class BillingBilledToHelper {
    public static getBilledToDictionnary(): { [id: string]: string } {
        return {
            "1": cacheStore.GetString("PatientLabel"),
            "2": cacheStore.GetString("ThirdPartyLabel")
        };
    }
}

export { BillingBilledToHelper };
